import { render, staticRenderFns } from "./LinkFormCard.vue?vue&type=template&id=31e95b61"
import script from "./LinkFormCard.vue?vue&type=script&lang=js"
export * from "./LinkFormCard.vue?vue&type=script&lang=js"
import style0 from "./LinkFormCard.vue?vue&type=style&index=0&id=31e95b61&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports